export default "<ion-list class=\"font16\">\r\n  <ion-item>KM </ion-item>\r\n  <ion-item>Price</ion-item>\r\n  <ion-item> Capacity </ion-item>\r\n</ion-list>";